import { useCallback, useContext, useEffect } from 'react';
import { HqoClientSdk } from '@hqo/hqo-miniapp-client-sdk';
import { MiniappSdkContext } from 'components/miniapp-sdk-provider/miniapp-sdk.context';
import { Handler } from '@hqo/hqo-miniapp-client-sdk/dist/sdk/types/sdk.interface';
import { SdkEvents } from '@hqo/hqo-miniapp-client-sdk/dist/sdk/types/sdk-handler.types';

export const getMiniappSdkClient = (appUuid?: string): HqoClientSdk =>
  new HqoClientSdk({
    app_uuid: appUuid,
    develop: false,
    init: true,
    init_timeout: 5000,
  });

export const useMiniappSdk = (): HqoClientSdk | null => useContext(MiniappSdkContext);

export const useMiniappSdkEventHandler = (
  eventName: SdkEvents,
  handler: Handler,
  handlerDependencies: unknown[],
): void => {
  const client = useMiniappSdk();
  const eventHandler = useCallback(handler, handlerDependencies);

  useEffect(() => {
    client?.on(eventName, eventHandler);
  }, [eventName, eventHandler]);
};
